import React from "react";
import {Helmet} from "react-helmet-async";
import styles from '../../styles/TextPages.module.css';
import logo from "../../assets/pokerly-logo-purple.svg";
import BurgerMenu from "../../components/common/BurgerMenu/BurgerMenu";
import footerBg from "../../assets/footer-bg.svg";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

const AboutPoints: React.FC = () => {
    const {t} = useTranslation();
    return (
        <>
            <Helmet>
                <title></title>
                <meta name="description" content={''}/>
                <meta property="og:type" content="website"/>
                <meta property="og:url" content={`https://pokerly.ru/points`}/>
                <meta property="og:title" content={''}/>
                <meta property="og:description" content={''}/>
                <meta property="og:image" content="https://pokerly.ru/og-image.png"/>
            </Helmet>
            <div className={styles.container}>
                <div className={styles.header}>
                    <div className={styles.backToVoting}>
                        ← <span>{t("backToVoting")}</span>
                    </div>
                    <div className={styles.logo}>
                        <Link to="/"><img src={logo} alt="Logo"/></Link>
                    </div>
                    <BurgerMenu/>
                </div>
                <div className={styles.main}>
                    <h1 className={styles.title}>
                        Как работает оценка?
                    </h1>
                    <p>
                        Pokerly помогает командам быстро и прозрачно прийти к общей оценке задач.
                    </p>
                    <p>
                        После того как все участники проголосовали, система рассчитывает несколько ключевых метрик,
                        чтобы показать согласованность команды и предложить итоговую рекомендацию.
                    </p>
                    <div className={styles.pointsItem}>
                        <p className={styles.subtitle}>
                            Среднее значение
                        </p>
                        <p className={styles.description}>
                            Показывает «среднюю температуру по больнице» — сглаженный ориентир по всем оценкам команды.
                        </p>
                        <div className={styles.quote}>
                            <b>Как считается:</b> Сумма всех числовых оценок делится на их количество. Используется
                            только для
                            числовых шкал (например, Фибоначчи). Если в шкале значения нечисловые (например, T-shirt
                            sizing), среднее не вычисляется.
                        </div>
                    </div>
                    <div className={styles.pointsItem}>
                        <p className={styles.subtitle}>
                            Медиана
                        </p>
                        <p className={styles.description}>
                            Наиболее устойчивое значение — отражает типичную оценку без влияния крайних мнений.
                        </p>
                        <div className={styles.quote}>
                            <b>Как считается: </b>
                            Все оценки сортируются, и выбирается центральная. Если шкала нечисловая, но упорядоченная
                            (например, XS &lt; S &lt; M &lt; L &lt; XL), Pokerly всё равно может определить медиану,
                            используя позицию значения в шкале. Таким образом, при голосах S, M, L медианой будет M.
                        </div>
                    </div>
                    <div className={styles.pointsItem}>
                        <p className={styles.subtitle}>
                            Разброс
                        </p>
                        <p className={styles.description}>
                            Показывает, насколько сильно команда расходится в оценках.
                        </p>
                        <ul>
                            <li>
                                <b>Для числовых шкал</b> — это разница между максимальной и минимальной оценкой.
                            </li>
                            <li>
                                <b>Для нечисловых шкал</b> — это разница между максимальной и минимальной оценкой.
                            </li>
                        </ul>
                        <div className={styles.quoteWrp}>
                            <div className={`${styles.quote} ${styles.quoteGreen}`}>
                                <div>
                                    <span></span>
                                    <b>Малый разброс</b>
                                </div>
                                Команда мыслит примерно одинаково, можно зафиксировать оценку.
                            </div>
                            <div className={`${styles.quote} ${styles.quoteYellow}`}>
                                <div>
                                    <span></span>
                                    <b>Средний разброс</b>
                                </div>
                                Мнения немного расходятся, стоит коротко уточнить детали.
                            </div>
                            <div className={`${styles.quote} ${styles.quoteRed}`}>
                                <div>
                                    <span></span>
                                    <b>Большой разброс</b>
                                </div>
                                Команда видит задачу по-разному, стоит обсудить причины и уточнить контекст.
                            </div>
                        </div>
                    </div>
                    <div className={styles.pointsItem}>
                        <p className={styles.subtitle}>
                            Рекомендация
                        </p>
                        <p className={styles.marginTop}>
                            Pokerly объединяет эти показатели, чтобы дать вам итоговый ориентир. Если оценки близки
                            — система предложит зафиксировать результат. Если разброс заметный — напомнит обсудить
                            задачу и пересмотреть оценку.
                        </p>
                        <p>
                            Для нечисловых шкал рекомендация основывается на наиболее часто встречающемся значении
                            (моде) и степени разнообразия ответов. Чем больше уникальных вариантов — тем выше
                            вероятность, что задача требует обсуждения.
                        </p>
                    </div>
                    <div className={styles.notice}>
                        <p>💡<b>Примечание:</b></p>
                        <p>Pokerly не пытается «усреднить» ваши мнения — система помогает увидеть, насколько команда
                            согласована и в каком направлении стоит двигаться: фиксировать результат или вернуться к
                            обсуждению.</p>
                    </div>
                </div>
                <div className={styles.footer}>
                    <img src={footerBg}/>
                    <div className={styles.footerContent}>
                        <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M18.6894 3.63159C18.3967 2.94165 17.9576 2.32698 17.3722 1.78757C16.7995 1.23562 16.0677 0.802838 15.1768 0.48923C14.2986 0.163077 13.2678 0 12.0842 0H0V14.1124H7.94156V11.7227H7.96065L7.97974 11.7039H12.0842C13.2423 11.7039 14.2604 11.5471 15.1386 11.2335C16.0168 10.9073 16.7486 10.4683 17.334 9.91631C17.9321 9.36435 18.3776 8.73714 18.6703 8.03465C18.9758 7.31963 19.1285 6.56697 19.1285 5.77667C19.1285 5.03655 18.9821 4.32153 18.6894 3.63159ZM7.95174 9.47349L7.94156 9.49482L7.93011 9.47349C7.22504 7.99075 5.13784 7.42751 5.13784 5.83438C5.13784 4.4131 7.14995 3.85739 7.94156 5.28995C8.7319 3.85739 10.744 4.4131 10.744 5.83438C10.744 7.42751 8.65681 7.99075 7.95174 9.47349Z"
                                fill="#9B9B9B"/>
                        </svg>
                        <p>
                            {t("footerDescription")}
                        </p>
                    </div>
                    <p className={styles.copyright}>
                        2026 © Made with ❤️ from us. All rights reserved.
                    </p>
                </div>
            </div>
        </>
    );
};

// @ts-ignore
export default AboutPoints;